module.exports = __webpack_public_path__ + "static/media/sofia.443a0bb8.jpeg";